<template>

    <!-- 5分钟接单率统计 -->
    <el-table
            :data="ticketTableData"
            height="300"
            style="width: 100%"
            :cell-style="cellStyle">
        <el-table-column
                prop="dcnumName"
                label="数据中心"
        >
        </el-table-column>
        <el-table-column
                prop="onTimeValue"
                label="事件准时接单率"
                width="100px"
        >
            <template slot-scope="scope">
                {{scope.row.onTimeValue == '0.00%' ? '-' : scope.row.onTimeValue}}
            </template>
        </el-table-column>
        <el-table-column
                prop="onTimeLevel1Value"
                label="一级事件准时接单率"
                width="100px">
            <template slot-scope="scope">
                {{scope.row.onTimeLevel1Value == '0.00%' ? '-' : scope.row.onTimeLevel1Value}}
            </template>
        </el-table-column>
        <el-table-column
                prop="onTimeLevel2Value"
                label="二级事件准时接单率"
                width="100px">
            <template slot-scope="scope">
                {{scope.row.onTimeLevel2Value == '0.00%' ? '-' : scope.row.onTimeLevel2Value}}
            </template>
        </el-table-column>
        <el-table-column
                prop="onTimeLevel3Value"
                label="三级事件准时接单率"
                width="100px">
            <template slot-scope="scope">
                {{scope.row.onTimeLevel3Value == '0.00%' ? '-' : scope.row.onTimeLevel3Value}}
            </template>
        </el-table-column>
    </el-table>

</template>

<script>
    import {formatDate} from "element-ui/src/utils/date-util";
    import TicketServer from "@/api/ticket";

    let that;

    export default {
        name: "ticketOnTimeStatistics",

        props: {
            dcnumids: {
                type: Array,
            },
            dcnumMap: null,
            searchDate: {
                type: String,
                default() {
                    return formatDate(new Date(), 'yyyy-MM');
                }
            },
        },

        async mounted() {

        },

        data() {
            return {
                ticketTableData: [],
            }
        },

        methods: {
            query() {
                let params = {
                    'dcnums': this.dcnumids,
                    'month': this.searchDate,
                    'class': 'INCIDENT',
                }
                let onTimeValuePromise = TicketServer.ticket.fetchOnTimeTicketOrderTake(params);
                params.level = 'LEVEL1';
                let onTimeValueLevel1Promise = TicketServer.ticket.fetchOnTimeTicketOrderTake(params);
                params.level = 'LEVEL2';
                let onTimeValueLevel2Promise = TicketServer.ticket.fetchOnTimeTicketOrderTake(params);
                params.level = 'LEVEL3';
                let onTimeValueLevel3Promise = TicketServer.ticket.fetchOnTimeTicketOrderTake(params);
                Promise.all([onTimeValuePromise, onTimeValueLevel1Promise, onTimeValueLevel2Promise, onTimeValueLevel3Promise]).then(res => {
                    this.ticketTableData = [];
                    let [onTimeValue, onTimeLevel1Value, onTimeLevel2Value, onTimeLevel3Value] = res;
                    for (let i = 0; i < that.dcnumids.length; i++) {
                        let lineData = {};
                        lineData.dcnumName = that.dcnumMap.get(that.dcnumids[i] + '');
                        lineData.onTimeValue = onTimeValue[that.dcnumids[i]] == null ? '' : onTimeValue[that.dcnumids[i]].toFixed(2) + '%';
                        lineData.onTimeLevel1Value = onTimeLevel1Value[that.dcnumids[i]] == null ? '' : onTimeLevel1Value[that.dcnumids[i]].toFixed(2) + '%';
                        lineData.onTimeLevel2Value = onTimeLevel2Value[that.dcnumids[i]] == null ? '' : onTimeLevel2Value[that.dcnumids[i]].toFixed(2) + '%';
                        lineData.onTimeLevel3Value = onTimeLevel3Value[that.dcnumids[i]] == null ? '' : onTimeLevel3Value[that.dcnumids[i]].toFixed(2) + '%';
                        that.ticketTableData.push(lineData);
                    }
                });
            },

            /**
             * 接单率低于97%的红色字体显示
             * @param row
             * @param column
             * @param rowIndex
             * @param columnIndex
             * @returns {string}
             */
            cellStyle({row, column, rowIndex, columnIndex}) {
                let num = 97;
                if (columnIndex == 1 && row.onTimeValue.substring(0, row.onTimeValue.length - 1) < num && row.onTimeValue.substring(0, row.onTimeValue.length - 1) != 0) {
                    return 'color: red';
                } else if (columnIndex == 2 && row.onTimeLevel1Value.substring(0, row.onTimeLevel1Value.length - 1) < num && row.onTimeLevel1Value.substring(0, row.onTimeValue.length - 1) != 0) {
                    return 'color: red';
                } else if (columnIndex == 3 && row.onTimeLevel2Value.substring(0, row.onTimeLevel2Value.length - 1) < num && row.onTimeLevel2Value.substring(0, row.onTimeValue.length - 1) != 0) {
                    return 'color: red';
                } else if (columnIndex == 4 && row.onTimeLevel3Value.substring(0, row.onTimeLevel3Value.length - 1) < num && row.onTimeLevel3Value.substring(0, row.onTimeValue.length - 1) != 0) {
                    return 'color: red';
                } else {
                    return '';
                }
            },

        },

        watch: {
            dcnumids: {
                immediate: true,
                handler: function (newVal, oldVal) {
                    if (newVal != null && newVal.length > 0) {
                        this.query();
                    }
                }
            },

            searchDate: {
                handler: function (newVal, oldVal) {
                    if (newVal != null && newVal != '') {
                        this.query();
                    }
                }
            },

        },

        created() {
            that = this;
        }

    }
</script>

<style scoped>

</style>